export default {
  COMPANY: 'company',
  CUSTOMER: 'customer',
} as const;
